module.exports = __webpack_public_path__ + "media/king.9ccb52c5.mp3";